import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";
import { Compass, Mail, Heart } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-border bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-2xl flex items-center justify-center bg-[hsl(var(--primary-red))] text-white">
              <Compass className="w-5 h-5" />
            </div>
            <span className="font-display text-xl font-semibold tracking-tight">
              <span className="text-[hsl(var(--primary-red))]">Tour</span>
              <span className="text-[hsl(var(--primary-green))]">.</span>AI
            </span>
          </Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">
            {t.hero.subtitle}
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/places" className="hover:text-foreground">{t.nav.places}</Link></li>
            <li><Link to="/map" className="hover:text-foreground">{t.nav.map}</Link></li>
            <li><Link to="/downloads" className="hover:text-foreground">{t.nav.downloads}</Link></li>
            <li><Link to="/admin" className="hover:text-foreground">{t.nav.admin}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">Contact</h4>
          <p className="text-sm text-muted-foreground flex items-center gap-2"><Mail className="w-4 h-4" /> hello@tour.ai</p>
          <p className="text-sm text-muted-foreground mt-3 flex items-center gap-1.5">
            Made with <Heart className="w-3.5 h-3.5 text-[hsl(var(--primary-red))]" />
          </p>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Tour.AI · All rights reserved
      </div>
    </footer>
  );
}
